import api from "@client/content/lib/api";
import { type ModuleApiInfo } from "@client/content/selectors";
import { type GenericMap } from "@client/types";
import { type HttpApiResponse } from "@client/types/Api";
import { type Data } from "@common/modules/data/types";
import { type ReportModule } from "./types";

export default {
  init: (
    apiInfo: ModuleApiInfo,
    args: ReportModule.Api.InitRequest
  ): Promise<HttpApiResponse<ReportModule.Api.InitResponse>> => api.get(apiInfo, `/api/site/v1/modules/report`, args),

  getChartData: (apiInfo: ModuleApiInfo, id: string, data: GenericMap<any>): Promise<HttpApiResponse<object[]>> =>
    api.put(apiInfo, `/api/site/v1/modules/report/${id}/chart/data`, data),
  getGridData: (apiInfo: ModuleApiInfo, id: string, data: GenericMap<any>): Promise<HttpApiResponse<object[]>> =>
    api.put(apiInfo, `/api/site/v1/modules/report/${id}/grid/data`, data),
  getReport: (apiInfo: ModuleApiInfo, id: string): Promise<HttpApiResponse<Data.Api.Report>> =>
    api.get(apiInfo, `/api/site/v1/modules/report/${id}`)
};
